import { render, staticRenderFns } from "./Iit.vue?vue&type=template&id=19f9b150&scoped=true"
import script from "./Iit.vue?vue&type=script&lang=js"
export * from "./Iit.vue?vue&type=script&lang=js"
import style0 from "./Iit.vue?vue&type=style&index=0&id=19f9b150&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f9b150",
  null
  
)

export default component.exports